// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__fOEyH","controlsRow":"styles_controlsRow__eS1vS","tabs":"styles_tabs__Jd_WD","pillsRow":"styles_pillsRow__OFpus"};